module.exports = __webpack_public_path__ + "static/media/carousel_rootbeer_1.235d06f8.jpg";